import React, { useContext, useMemo } from 'react';
import { ORDER_STATUSES } from '@ubeya/shared/constants';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import styled from 'styled-components';

const Label = styled.div`
  width: calc(100% - 4px);
  margin: 2px;
  border-radius: 2px;
  padding: 6px;
  text-align: center;
  font-weight: 500;
  font-size: 14rem;
  line-height: 22rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  border: 4px solid ${({ theme }) => theme.colors.white};
  outline: 1px solid ${({ theme }) => theme.colors.grey2};
  cursor: pointer;
`;

const OrderStatusSelect = ({ value, onClick }) => {
  const { t } = useContext(ConfigContext);

  const options = useMemo(
    () =>
      Object.entries(ORDER_STATUSES).map(([, { label, background, color, showOnSelect }]) => ({
        value: label,
        label: t(label),
        background,
        color,
        showOnSelect
      })),
    [t]
  );

  const styles = options.find(({ value: optionValue }) => optionValue === value);

  return (
    <Label
      onClick={onClick}
      style={{
        background: styles?.background,
        color: styles?.color
      }}>
      {styles.label}
    </Label>
  );
};

export default OrderStatusSelect;
